import { resolveBrandProfile } from '@/Ship/Configs/brands'

import type { BrandProfile } from '@/Ship/Configs/brands'

/**
 * Бренд стенду — одне джерело правди.
 *
 * Назва раніше була вписана текстом у трьох місцях (сайдбар, прелоадер,
 * `index.html`), і кожен новий екран додавав четверте. Тепер усе, чим бренди
 * відрізняються, лежить у профілях `Ship/Configs/brands/` (ADR 048), а
 * активний обирає змінна `VITE_BRAND` під час запуску чи збирання Vite.
 * Без неї — Астерікс.
 */
export const BrandConfig: BrandProfile = resolveBrandProfile(import.meta.env['VITE_BRAND'] as string | undefined)
